<ng-template #outlineActions>
  <button
    *ngIf="!drawerOpen"
    uiButton
    type="button"
    [text]="true"
    [outlined]="false"
    class="workflow-process-rail__toggle"
    [attr.aria-label]="expanded ? 'Collapse Steps' : 'Expand Steps'"
    [title]="expanded ? 'Collapse Steps' : 'Expand Steps'"
    [attr.aria-expanded]="expanded"
    aria-controls="workflow-process-steps"
    (click)="toggleRequested.emit()"
  >
    <i
      class="pi"
      [class.pi-angle-double-left]="expanded"
      [class.pi-angle-double-right]="!expanded"
      aria-hidden="true"
    ></i>
  </button>
  <button
    *ngIf="drawerOpen"
    uiButton
    type="button"
    [text]="true"
    [outlined]="false"
    class="workflow-steps-drawer-close"
    aria-label="Close Steps"
    title="Close Steps"
    (click)="closeRequested.emit()"
  >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
</ng-template>

<ui-panel
  class="workflow-step-outline__panel"
  width="fill"
  panelTitle="Steps"
  title="Workflow steps"
  [headerActionsTemplate]="outlineActions"
  [noGrow]="true"
  [flexGap]="'none'"
>
  <nav
    id="workflow-process-steps"
    class="workflow-step-outline__body"
    aria-label="Workflow steps"
    [hidden]="!expanded && !drawerOpen"
  >
    <ol class="workflow-step-outline__list">
      <li
        *ngFor="let entry of entries; trackBy: trackEntry"
        class="workflow-process-rail__step-row"
      >
        <button
          uiButton
          type="button"
          [text]="true"
          [outlined]="false"
          [wrap]="true"
          class="workflow-process-rail__step"
          [attr.data-outline-node]="entry.nodeId"
          [attr.aria-current]="
            entry.nodeId !== null && entry.nodeId === selectedNodeId
              ? 'step'
              : null
          "
          [disabled]="blocked || !entry.inspectable || entry.nodeId === null"
          (click)="requestNode(entry)"
        >
          <i class="pi" [ngClass]="entry.icon" aria-hidden="true"></i>
          <span class="workflow-step-outline__identity">
            <span class="workflow-step-outline__label">{{ entry.label }}</span>
            <span class="workflow-step-outline__type">{{
              entry.typeLabel
            }}</span>
          </span>
        </button>
        <button
          *ngIf="entry.issueCount > 0"
          uiButton
          type="button"
          [text]="true"
          [outlined]="false"
          class="workflow-process-rail__issue-badge"
          [disabled]="blocked || !entry.inspectable || entry.nodeId === null"
          [attr.aria-label]="entry.issueCount + ' issues for ' + entry.label"
          [title]="entry.issueCount + ' issues for ' + entry.label"
          (click)="requestIssues(entry)"
        >
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          <span>{{ entry.issueCount }}</span>
        </button>
      </li>
    </ol>
  </nav>
</ui-panel>
